// Plugin Registration
// Register all plugins here

import { PluginRegistry } from './registry';
import { realtorManifest } from './realtor/manifest';

// Register plugins
export function registerPlugins() {
  console.log('=== registerPlugins() CALLED ===');
  console.log('realtorManifest:', realtorManifest);
  PluginRegistry.register(realtorManifest);
  console.log('=== registerPlugins() DONE, total:', PluginRegistry.getAll().length);
}

// Export registry and types
export { PluginRegistry } from './registry';
export type { 
  PluginManifest, 
  PluginRoute, 
  NavigationItem, 
  DashboardWidget, 
  MenuItem,
  PluginRouteWithMeta,
  DashboardWidgetWithMeta,
  MenuItemWithMeta,
} from './types';
